import { func, object, arrayOf } from 'prop-types';
import React from 'react';

import QuestionBlock from './QuestionBlock';
import RehabHeader from './RehabHeader';
import { AnswerItem } from './AnswerItem';
import FormDialog from '../../OnlineRehabilitation/components/FormDialog';
import normalize from 'lib/normalize';
import calculateMSNQTotals from '../../Scores/calculateMSNQ';
import calculateFSMCTotals from '../../Scores/calculateFSMC';
import { path } from 'ramda';
import StatusForm from '../../Status/components/StatusForm';
import EQ5DForm from '../../QualityOfLife/components/EQ5DForm';
import MSNQForm from '../../Scores/components/MSNQForm';
import FSMCForm from '../../Scores/components/FSMCForm';
import MSNQInfo from '../../Scores/components/MSNQInfo';
import FSMCInfo from '../../Scores/components/FSMCInfo';

const View1 = ({ fm, data, documents }) => {
  const msnqDoc = documents.find(d => d.documentId === data.msnq);
  const fsmcDoc = documents.find(d => d.documentId === data.fsmc);

  const [viewing, setViewing] = React.useState(null);

  const totalsDoc = type =>
    type === 'msnq'
      ? normalize(calculateMSNQTotals([msnqDoc]))[0]
      : type === 'fsmc'
        ? calculateFSMCTotals([fsmcDoc])[0]
        : null;

  const openDialog = (type, id, info = false) => {
    setViewing({ type, id, totals: info ? totalsDoc(type) : null });
  };

  const closeDialog = () => {
    setViewing(null);
  };
  return (
    <div>
      <QuestionBlock
        question={fm('npView.rehab8.status')}
        answer={data.status ? <AnswerItem type={'status'} id={data.status} openDialog={openDialog} /> : null}
      />
      <QuestionBlock
        question={fm('onlineRehabilitation.rehab8.2.h2')}
        answer={data.eq5d ? <AnswerItem type={'eq5d'} id={data.eq5d} openDialog={openDialog} /> : null}
      />
      <QuestionBlock
        question={fm('onlineRehabilitation.rehab8.3.h2')}
        answer={data.msnq ? <AnswerItem type={'msnq'} id={data.msnq} openDialog={openDialog} /> : null}
      />
      <QuestionBlock
        question={fm('onlineRehabilitation.rehab8.4.h2')}
        answer={data.fsmc ? <AnswerItem type={'fsmc'} id={data.fsmc} openDialog={openDialog} /> : null}
      />
      <FormDialog
        dialogOpen={!!viewing}
        type={path(['type'], viewing)}
        form={
          path(['type'], viewing) === 'status'
            ? StatusForm
            : path(['type'], viewing) === 'eq5d'
              ? EQ5DForm
              : path(['type'], viewing) === 'msnq'
                ? MSNQForm
                : path(['type'], viewing) === 'fsmc'
                  ? FSMCForm
                  : null
        }
        infoComponent={
          path(['totals'], viewing) && path(['type'], viewing) === 'msnq' ? (
            <MSNQInfo document={path(['totals'], viewing)} />
          ) : path(['totals'], viewing) && path(['type'], viewing) === 'fsmc' ? (
            <FSMCInfo document={path(['totals'], viewing)} />
          ) : null
        }
        documents={documents}
        viewingId={path(['id'], viewing)}
        closeCallback={closeDialog}
        fm={fm}
      />
    </div>
  );
};
View1.propTypes = {
  fm: func,
  data: object,
  documents: arrayOf(object),
};

const Rehab8 = ({ fm, data, documents }) => {
  return (
    <React.Fragment>
      <RehabHeader fm={fm} rehab={8} date={data.finished} />
      <View1 {...{ fm, data, documents }} />

      {/* View2 */}
      <QuestionBlock
        question={fm('npView.rehab8.fatigueNow')}
        answer={
          data.currentFatigueStatusSelected
            ? fm(`onlineRehabilitation.controlSteps.${data.currentFatigueStatusSelected}`)
            : null
        }
      />
      <QuestionBlock
        question={fm('npView.rehab8.cognitionNow')}
        answer={
          data.currentCognitionStatusSelected
            ? fm(`onlineRehabilitation.controlSteps.${data.currentCognitionStatusSelected}`)
            : null
        }
      />

      {/* View3 */}
      <QuestionBlock question={fm('onlineRehabilitation.rehab8.7.fatigueBenefit')} answer={data.fatigueBenefit} />
      <QuestionBlock question={fm('onlineRehabilitation.rehab8.7.cognitionBenefit')} answer={data.cognitionBenefit} />
      <QuestionBlock
        question={fm('onlineRehabilitation.rehab8.7.studyingWorkingNow')}
        answer={data.studyingWorkingNow}
      />
      <QuestionBlock
        question={fm('onlineRehabilitation.rehab8.7.rehabilitationBenefit')}
        answer={data.rehabilitationBenefit}
      />
      <QuestionBlock question={fm('onlineRehabilitation.rehab8.7.rehabExperiences')} answer={data.rehabExperiences} />

      <QuestionBlock
        question={fm('onlineRehabilitation.rehab8.7.rehabFatigueCognitionBenefit')}
        answer={
          data.rehabFatigueCognitionBenefit
            ? fm(`onlineRehabilitation.rehab8.${data.rehabFatigueCognitionBenefit}`)
            : null
        }
      />
      <QuestionBlock
        question={fm('onlineRehabilitation.rehab8.7.rehabFatigueCognitionBenefitDetails')}
        answer={data.rehabFatigueCognitionBenefitDetails}
      />

      <QuestionBlock
        question={fm('onlineRehabilitation.rehab8.7.rehabTechnicalFunctioning')}
        answer={
          data.rehabTechnicalFunctioning ? fm(`onlineRehabilitation.rehab8.${data.rehabTechnicalFunctioning}`) : null
        }
      />
      <QuestionBlock
        question={fm('onlineRehabilitation.rehab8.7.rehabTechnicalFunctioningDetails')}
        answer={data.rehabTechnicalFunctioningDetails}
      />

      <QuestionBlock
        question={fm('onlineRehabilitation.rehab8.7.improvementSuggestions')}
        answer={data.improvementSuggestions}
      />
      <QuestionBlock question={fm('onlineRehabilitation.rehab8.7.otherComments')} answer={data.otherComments} />
    </React.Fragment>
  );
};

Rehab8.propTypes = {
  fm: func,
  data: object,
  documents: arrayOf(object),
};
export default Rehab8;
